import React from 'react';
import './ui.scss';

export const Skeleton = ({ variant = 'text', className = '', style }) => (
  <div
    className={`builder-ui-skeleton builder-ui-skeleton--${variant} ${className}`}
    style={style}
    aria-hidden="true"
  />
);

export default Skeleton;
